// Single source of truth for the app version shown in UI.
// Bump this on each release and keep in sync with backend/server.py `version`.
export const APP_VERSION = "1.5.6";
